import { useEffect, useMemo, useRef, useState } from 'react';
import EfVideo from '@elem/ui/ef-video';
import { useMediaDevice } from '../../hooks';
import styles from './index.module.scss';
import { useLang } from '@/i18n';

export default function TheComp() {
    const { isH5, isPad, isPC, isDesktop, isInit } = useMediaDevice();
    const { t } = useLang('Oasis.BannerA');

    // 初始化动画
    const infoRef = useRef<HTMLDivElement>(null);
    const initAni = useRef(false);
    const [loopAni, setLoopAni] = useState(false);
    useEffect(() => {
        if (!initAni.current && isInit && infoRef.current) {
            initAni.current = true;
            infoRef.current.classList.add('enter');
            const startVideoContainer = document.querySelector('#BannerA .video-start') as HTMLDivElement;
            const video = document.querySelector('#BannerA .video-start video') as HTMLVideoElement;
            const callback = () => {
                setLoopAni(true);
                startVideoContainer.style.opacity = '0';
            };
            video?.addEventListener('ended', callback);
            return () => {
                video?.removeEventListener('ended', callback);
            };
        }
    }, [isInit]);

    // 消失隐藏动画
    useEffect(() => {
        if (typeof window !== 'undefined') {
            const bannerInfo: HTMLDivElement | null = document.querySelector('#BannerA .banner-info');
            if (bannerInfo) {
                const ani = AniContainer.create({
                    triggerElement: bannerInfo,
                    triggerHook: 0, // 1 进入视窗 0 离开视窗
                    offset: -bannerInfo.offsetHeight,
                    duration: bannerInfo.offsetHeight * 2,
                    syncFromTo: [[bannerInfo, { opacity: 1 }, { opacity: 0 }, 0.1]],
                });
                return () => {
                    ani.destroy();
                };
            }
        }
    }, [isH5, isPad, isPC, isDesktop]);

    const videoElement = useMemo(() => {
        if (!isInit) return null;
        return isH5 ? (
            <>
                <EfVideo
                    className="video-start"
                    pc="https://websiteoss.ecoflow.com/upload/video/1735631507101/BannerA-start.mp4"
                    autoPlay
                    key="banner-video-pc-start"
                    poster="https://websiteoss.ecoflow.com/upload/image/1735786346010/KV_M.png"
                    preload="none"
                />
                <EfVideo
                    className="video-end"
                    pc="https://websiteoss.ecoflow.com/upload/video/1735631507268/BannerA-loop.mp4"
                    poster="https://websiteoss.ecoflow.com/upload/image/1735786346010/KV_M.png"
                    startPlay={loopAni}
                    loop
                    key="banner-video-pc-loop"
                    preload="none"
                />
            </>
        ) : (
            <>
                <EfVideo
                    className="video-start"
                    pc="https://websiteoss.ecoflow.com/upload/video/1735631802587/BannerA-start-h5.mp4"
                    autoPlay
                    key="banner-video-h5-start"
                    poster="https://websiteoss.ecoflow.com/upload/image/1735786346121/KV.png"
                />
                <EfVideo
                    className="video-end"
                    pc="https://websiteoss.ecoflow.com/upload/video/1735631802755/BannerA-loop-h5.mp4"
                    poster="https://websiteoss.ecoflow.com/upload/image/1735786346121/KV.png"
                    startPlay={loopAni}
                    loop
                    key="banner-video-h5-loop"
                />
            </>
        );
    }, [isInit, isH5, loopAni]);
    return (
        <div className={`${styles.TheComp}`} id="BannerA">
            <div className="banner-info-container" ref={infoRef}>
                <div className="banner-info">
                    <div className="banner-btn">{t('label')}</div>
                    <div className="banner-title">{t('title')}</div>
                    <div className="banner-desc">
                        {t.rich('desc', {
                            h: (v: string) => <span className="highlight">{v}</span>,
                        })}
                    </div>
                    {/* <div className="banner-play">
                    <span>{t('video')}</span>
                    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none">
                        <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M7.84603 0.0722656C3.91675 0.0722656 0.731445 3.25757 0.731445 7.18685C0.731445 11.1161 3.91675 14.3014 7.84603 14.3014C11.7753 14.3014 14.9606 11.1161 14.9606 7.18685C14.9606 3.25757 11.7753 0.0722656 7.84603 0.0722656ZM10.2922 7.47511C10.4889 7.33312 10.4889 7.04018 10.2922 6.8982L6.98701 4.51291C6.75174 4.34312 6.42311 4.51123 6.42311 4.80136L6.42311 9.57194C6.42311 9.86207 6.75174 10.0302 6.98701 9.86039L10.2922 7.47511Z"
                            fill="white"
                        />
                    </svg>
                </div> */}
                </div>
            </div>
            {videoElement}
        </div>
    );
}
